<template>

    <div class="w-full mb-6">
        <div class="flex flex-wrap w-full font-bold bg-gray-300 rounded text-gray-800 shadow-md mb-6">
			<div class="w-full py-3 px-4 md:w-auto -mb-3 md:mb-0">
				<router-link tag="button" to="/admin/sales/add" class="bg-green-600 text-white rounded px-2 py-1">
                    Add Sale
                </router-link>
			</div>
            
			<div class="flex-1 text-left py-3 px-4 w-full md:w-auto md:text-right">
				<router-link tag="button" to="/admin/sales/pending" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Pending Sales
				</router-link>
				<router-link tag="button" to="/admin/sales/processing" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Processing Sales
				</router-link>
				<!-- <router-link tag="button" to="/admin/sales/completed" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Completed Sales
				</router-link> -->
                <router-link tag="button" to="/admin/sales/search" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Sale Search
				</router-link>
			</div>
		</div>

        <Card class="w-full">
            <template v-slot:header>
                Search Sales
            </template>
            <template v-slot:body>
                <div class="p-6 clearfix">
                    <p class="pb-6">You do not need to enter a stringer... Only enter a stringer to narrow results.</p>
                    <div class="md:flex md:items-center mb-6">
                        <div class="md:w-1/3">
                            <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                                Stringer
                            </label>
                        </div>
                        <div class="md:w-2/3">
                            <v-select :debounce="250" @search="getSearchUsers" :options="userCollection" v-model="user" placeholder="Search for a user..." label="name"></v-select>
                        </div>
                    </div>

                    <div class="md:flex md:items-center mb-6">
                        <div class="md:w-1/3">
                            <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                                Invoice ID
                            </label>
                        </div>
                        <div class="md:w-2/3">
                            <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="number" v-model="invoiceId">
                        </div>
                    </div>

                    <button class="bg-blue-700 px-2 py-1 text-white rounded float-none md:float-right w-full md:w-auto focus:outline-none" v-on:click="getSearchInvoices">
                        <span v-if="!loading">Search</span>
                        <span v-if="loading"><i class="fa fa-circle-notch fa-spin"></i></span>
                    </button>
                </div>
                <CustomTable class="mt-4 border-t border-grey-light" v-if="sales.length !== 0">
                    <template v-slot:header>
                        <th class="bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Sale Details</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Video</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Invoice Number</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Date</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Amount</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
                    </template>
                    <template v-slot:body>
                        <tr v-for="sale in sales">
                            <td class="py-4 pl-4 border-b border-grey-light">
                                <span class="w-2 h-2 rounded-full bg-blue-700 inline-block cursor-pointer" v-if="sale.method == 'cdn'" title="CDN" v-tippy></span>
                                <span class="w-2 h-2 rounded-full bg-green-700 inline-block cursor-pointer" v-if="sale.method == 'email'" title="Email" v-tippy></span>
                                <span class="w-2 h-2 rounded-full bg-black inline-block cursor-pointer" v-if="sale.method == 'manual'" title="Manual" v-tippy></span>
                            </td>
                            <td class="py-4 px-2 border-b border-grey-light text-center">
                                <strong>{{ sale.network.name }}</strong> <br/>
                                <small>({{ sale.purchaser.name }})</small> <br />
                                <i class="fa fa-exchange"></i> <br/>
                                {{ sale.owner.name }} <br />
                            </td>
                            <td class="py-4 px-2 border-b border-grey-light">{{ sale.video.title }}</td>
                            <td class="py-4 px-2 border-b border-grey-light">{{ sale.invoice_number }}</td>
                            <td class="py-4 px-2 border-b border-grey-light">{{ sale.created_at | displayLocalDateTime }}</td>
                            <td class="py-4 px-2 border-b border-grey-light">${{ sale.price }} / <span v-if="sale.stringer_cut !== null">${{ sale.stringer_cut }}</span><span v-if="sale.stringer_cut == null">N/A</span></td>
                            <td class="py-4 pl-2 pr-4 border-b border-grey-light text-right">
                                <button class="bg-green-600 px-2 py-1 text-white text-sm rounded ml-2" v-if="sale.status == 'occurring'" v-on:click="finalizeSale(sale)">
                                    Finalize
                                </button>
                                <button class="bg-blue-700 px-2 py-1 text-white text-sm rounded ml-2" v-if="sale.status == 'pending'" v-on:click="viewApproveSaleModal(sale)">
                                    Approve
                                </button>
                            </td>
                        </tr>
                    </template>
                </CustomTable>
            </template>
        </Card>
        <approve-sale-modal></approve-sale-modal>
    </div>
			
</template>

<script>

    import { EventBus } from '@/utils/events';
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import ApproveSaleModal from '../../modals/ApproveSaleModal'

    import CustomTable from '@/components/general/CustomTable'
	import Card from '@/components/partials/Card'

    export default {
        data() {
            return {
                userCollection: [],
                user: null,

                invoiceId: null,
                
                sales: [],
                loading: false,
            }
        },

        components: {
            'approve-sale-modal': ApproveSaleModal,
            CustomTable,
            Card
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            getSearchUsers(search, loading) {
                loading(true)

                var data = {
                    name: search,
                }

                this.$http.post(Config.apiPath + '/api/v2/admin/users/search/stringers', data, this.getAuthorizationHeader())
                    .then(response => {
                        this.$set(this, 'userCollection', response.data)
                        loading(false)
                    })
            },

            getSearchInvoices() {
                this.loading = true;

                if(this.user !== null) {
                    var data = {
                        invoice_number: this.invoiceId,
                        user: this.user.id,
                    }
                } else {
                    var data = {
                        invoice_number: this.invoiceId,
                    }
                }

                this.$http.post(Config.apiPath + '/api/v2/admin/sales/search/invoices', data, this.getAuthorizationHeader())
                    .then(response => {
                        this.$set(this, 'sales', response.data)
                        this.$set(this, 'loading', false)
                    })
            },

            finalizeSale(sale) {
                var _this = this;
                this.$swal({
                    title: 'Finalize sale?',
                    text: "Finalizing this sale will mark this sale as complete, and notify the user that payment is on it's way.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, finalize sale!'
                }).then((result) => {
                    if (result.value) {
                        var data = {
                            id: sale.id,
                        }
                        // send mail
                        _this.$http.post(Config.apiPath + "/api/v2/admin/sales/finalize", data, _this.getAuthorizationHeader()).then((response) => {
                            _this.$swal(
                                'Complete!',
                                'The sale has been marked as complete.',
                                'success'
                            )
                            sale.status = 'complete';
                        });
                    }
                })
            },

            viewApproveSaleModal(data) {
                EventBus.$emit('admin-approve-sale-open-modal', data);
            },

        },
        watch: {
            video: function(data) {
                this.price = data.price;
            }
        },
        filters: {
            displayMethod: function(data) {
                if(data == 'email') {
                    return "Email"
                } else if(data == 'cdn') {
                    return "CDN"
                } else if(data == 'manual') {
                    return "Manual"
                }
            },
            displayLocalDateTime: function(data) {
                return moment.utc(data).local().format('MM/DD/YY h:mm a');
            }
        }
        
    }
</script>

<style scoped>

</style>
